var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"proposal-upvote-card"},[_c('v-btn',{staticClass:"upvote-button",attrs:{"height":"45px","color":"primary"},on:{"click":_vm.tapWithdraw}},[_vm._v(" Withdraw ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }